import { useState, useEffect, useRef } from 'react';

function useScrollTop(offset) {
  const ref = useRef();
  const [isTop, setIsTop] = useState(false);
  const yOffset = useRef(0);
  const [isScrolledUp, setIsScrolledUp] = useState(false);
  useEffect(() => {
    const handler = () => {
      const rect = ref.current?.getBoundingClientRect();
      const top = rect?.top ?? 0;
      setIsTop(top <= offset);
      if (yOffset.current < window.scrollY) {
        setIsScrolledUp(false);
      } else {
        setIsScrolledUp(true);
      }
      yOffset.current = window.scrollY;
    };

    window.addEventListener('scroll', handler);
    return () => {
      window.removeEventListener('scroll', handler);
    };
  }, [offset]);

  return { ref, isTop, isScrolledUp };
}

export { useScrollTop };
